import _ from 'underscore';
import React from 'react';

export default function SelectOptions(option) {
  let optionStyle = { color: '#999', float: 'right' };

  return (
    <div>
      <span>{option.label}</span>
      <If condition={!_.isEmpty(option.customLabel)}>
        <span
          className='customLabel'
          style={optionStyle}
        >
          ({option.customLabel})
        </span>
      </If>
    </div>
  );
}
